/* global System */

export default {
  OguloMapTeaser: () =>
    System.import(/* webpackChunkName: "OguloMapTeaser" */ './index'),
}
